export function isEditorEmpty(html) {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.innerText.trim() === '';
}

export function cleanQuillHtml(html) {
  const container = document.createElement('div');
  container.innerHTML = html;

  const isEmptyNode = (node) => {
    const text = node.textContent?.replace(/\u200B/g, '').trim();
    const hasOnlyBr = node.innerHTML?.replace(/\u200B/g, '').trim() === '<br>';
    return !text || hasOnlyBr;
  };

  const children = Array.from(container.childNodes);

  while (children.length && children[0].nodeType === 1 && isEmptyNode(children[0])) {
    container.removeChild(children[0]);
    children.shift();
  }

  while (children.length && children[children.length - 1].nodeType === 1 && isEmptyNode(children[children.length - 1])) {
    container.removeChild(children[children.length - 1]);
    children.pop();
  }

  return container.innerHTML.trim();
}
